import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";

// FIREBASE_CONFIG はビルド時に esbuild が埋め込む（コンソールの SDK 設定 JSON）
const app = initializeApp(JSON.parse(process.env.FIREBASE_CONFIG as unknown as string));
export const db = getFirestore(app);
const fns = getFunctions(app, "asia-northeast1");
const auth = getAuth(app);

export class CallError extends Error { constructor(public code: string, message: string, public details?: unknown) { super(message); } }
export async function call<T>(name: string, data: unknown): Promise<T> {
  try { return (await httpsCallable(fns, name)(data)).data as T; }
  catch (e: any) { throw new CallError(e?.details?.code ?? e?.code ?? "unknown", e?.message ?? "エラーが発生しました。お手数ですが、もう一度お試しください", e?.details?.details); }
}
export async function signInAdmin() { await signInWithPopup(auth, new GoogleAuthProvider()); }
export async function signOutAdmin() { await signOut(auth); }
export function onAdmin(cb: (email: string | null) => void) { onAuthStateChanged(auth, (u) => cb(u?.email ?? null)); }
